import React from "react";
import {Button, notification, Slider} from "antd";
import {
    SaveOutlined,
} from '@ant-design/icons';
import './Schedule.less';
import Div from "../views/Div";
import PageHeader from "../views/PageHeader";
import BlockHeader from "../views/BlockHeader";
import Card from "../views/Card";
import Sections from "../views/Sections";
import SystemFunctions from "../../helpers/SystemFunctions";
import SData from "../../helpers/SData";
import Server from "../../helpers/Server";

export default class Schedule extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            leftRouterState: false,

            weekMonday: SData.base.data.schedule[0],
            weekTuesday: SData.base.data.schedule[1],
            weekWednesday: SData.base.data.schedule[2],
            weekThursday: SData.base.data.schedule[3],
            weekFriday: SData.base.data.schedule[4],
            weekSaturday: SData.base.data.schedule[5],
            weekSunday: SData.base.data.schedule[6],

            loading: false,
        };
    }

    renderResultsDay = (value) => {
        if (value[1] - value[0] < 2) {
            return <b className='dayOff'>выходной</b>;
        }
        return <b>{value[1] - value[0] + ' ' + SystemFunctions.wordDeclensionNumeric(value[1] - value[0], 'час', 'часа', 'часов')}</b>;
    }

    renderResultsBlock = () => {
        let days = ['weekMonday', 'weekTuesday', 'weekWednesday', 'weekThursday', 'weekFriday', 'weekSaturday', 'weekSunday'];
        let sumHours = 0;
        let workDays = 0;
        for (const daysKey in days) {
            if (this.state[days[daysKey]][1] - this.state[days[daysKey]][0] > 1) {
                sumHours += this.state[days[daysKey]][1] - this.state[days[daysKey]][0];
                workDays++;
            }
        }
        let hourPay = SData.base.salary;
        return (<Card className='weekResults'>
            <div className='item'>
                <div className='title'>Рабочих часов в неделю</div>
                <div className='value'>{sumHours} {sumHours !== 40 ? <span className='recommend'>(рекоменд. - <span
                    className='recommendValue'>40</span>)</span> : null}</div>
            </div>
            <div className='item'>
                <div className='title'>Итоговый график</div>
                <div
                    className='value'>{workDays > 0 ? Math.round(sumHours / workDays) : 0} / {workDays} {Math.round(sumHours / workDays) !== 8 || workDays !== 5 ?
                    <span className='recommend'>(рекоменд. - <span
                        className='recommendValue'>8 / 5</span>)</span> : null}</div>
            </div>
            <div className='item last'>
                <div className='title'>Примерная зарплата</div>
                <div className='value'>{SystemFunctions.formatNumber(hourPay * sumHours * 4)} ₽ / месяц</div>
            </div>
        </Card>);
    }

    render() {
        return (
            <div className='Schedule'>
                <PageHeader title='График работы'/>
                <Div>
                    <Sections>
                        <div className='leftPart'>
                            <BlockHeader text='Настройка недели' status='blue'/>
                            <Card className='weekSettings'>
                                <div className='dayTitle'>Понедельник: {this.renderResultsDay(this.state.weekMonday)}
                                </div>
                                <Slider range value={this.state.weekMonday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekMonday)} onChange={(v) => {
                                    this.setState({weekMonday: v});
                                }}/>
                                <br/>
                                <div className='dayTitle'>Вторник: {this.renderResultsDay(this.state.weekTuesday)}
                                </div>
                                <Slider range value={this.state.weekTuesday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekTuesday)} onChange={(v) => {
                                    this.setState({weekTuesday: v});
                                }}/>
                                <br/>
                                <div className='dayTitle'>Среда: {this.renderResultsDay(this.state.weekWednesday)}
                                </div>
                                <Slider range value={this.state.weekWednesday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekWednesday)}
                                        onChange={(v) => {
                                            this.setState({weekWednesday: v});
                                        }}/>
                                <br/>
                                <div className='dayTitle'>Четверг: {this.renderResultsDay(this.state.weekThursday)}
                                </div>
                                <Slider range value={this.state.weekThursday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekThursday)} onChange={(v) => {
                                    this.setState({weekThursday: v});
                                }}/>
                                <br/>
                                <div className='dayTitle'>Пятница: {this.renderResultsDay(this.state.weekFriday)}
                                </div>
                                <Slider range value={this.state.weekFriday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekFriday)} onChange={(v) => {
                                    this.setState({weekFriday: v});
                                }}/>
                                <br/>
                                <div className='dayTitle'>Суббота: {this.renderResultsDay(this.state.weekSaturday)}
                                </div>
                                <Slider range value={this.state.weekSaturday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekSaturday)} onChange={(v) => {
                                    this.setState({weekSaturday: v});
                                }}/>
                                <br/>
                                <div className='dayTitle'>Воскресенье: {this.renderResultsDay(this.state.weekSunday)}
                                </div>
                                <Slider range value={this.state.weekSunday} min={0} max={24}
                                        marks={this.createSliderMarksObject(this.state.weekSunday)} onChange={(v) => {
                                    this.setState({weekSunday: v});
                                }}/>
                            </Card>
                            <Button className='saveWeek blue' size='large' type='primary' icon={<SaveOutlined/>}
                                    onClick={this.onClickSave} loading={this.state.loading}>Сохранить изменения</Button>
                        </div>
                        <div className='rightPart'>
                            <BlockHeader text='Оценка' status='warning'/>
                            {this.renderResultsBlock()}
                        </div>
                    </Sections>
                </Div>
            </div>
        );
    }

    onClickSave = () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let schedule = [
            this.state.weekMonday,
            this.state.weekTuesday,
            this.state.weekWednesday,
            this.state.weekThursday,
            this.state.weekFriday,
            this.state.weekSaturday,
            this.state.weekSunday,
        ];
        Server.query(Server.QUERY_ACTIONS, {a: 'saveSchedule', schedule}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                this.setState({loading: false});
                this.loadScheduleFromBase();
                notification.success({
                    message: 'График работы сохранен',
                    placement: 'bottomRight',
                });
            } else {
                this.setState({loading: false});
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }

    createSliderMarksObject = (value) => {
        let obj = {};
        if (value[0] > 1) {
            obj[0] = 0;
        }
        if (value[1] < 23) {
            obj[24] = 24;
        }
        if ((value[0] > 6 || value[1] < 6) && value[0] !== 5 && value[0] !== 7 && value[1] !== 5 && value[1] !== 7) {
            obj[6] = 6;
        }
        if ((value[0] > 12 || value[1] < 12) && value[0] !== 11 && value[0] !== 13 && value[1] !== 11 && value[1] !== 13) {
            obj[12] = 12;
        }
        if ((value[0] > 18 || value[1] < 18) && value[0] !== 17 && value[0] !== 19 && value[1] !== 17 && value[1] !== 19) {
            obj[18] = 18;
        }
        obj[value[0]] = value[0];
        obj[value[1]] = value[1];
        return obj;
    }

    loadScheduleFromBase = () => {
        this.setState({
            weekMonday: SData.base.data.schedule[0],
            weekTuesday: SData.base.data.schedule[1],
            weekWednesday: SData.base.data.schedule[2],
            weekThursday: SData.base.data.schedule[3],
            weekFriday: SData.base.data.schedule[4],
            weekSaturday: SData.base.data.schedule[5],
            weekSunday: SData.base.data.schedule[6],
        });
    }
}